var _path, _circle, _line;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeCrossedOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m12,5.601c-4.266,0-7.909,2.654-9.386,6.399,1.476,3.746,5.119,6.399,9.386,6.399s7.909-2.654,9.386-6.399c-1.476-3.746-5.119-6.399-9.386-6.399Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 11.994,
    r: 3.483
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 16.737,
    y1: 3.523,
    x2: 7.263,
    y2: 20.477
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeCrossedOut);
export default __webpack_public_path__ + "static/media/eye-crossed-out.41b57418599f76ac7f17107202df69e9.svg";
export { ForwardRef as ReactComponent };